import { Button } from "shared/ui/button";
import { useMobile } from "shared/lib/hooks";
import { DisabledElementModal } from "widgets/disabled-element-modal";
import { useModal } from "shared/ui/modal";
import Kntech from "../assets/Kntech.png";
import Epline from "../assets/Epline.png";
import Phitogen from "../assets/Phitogen.png";
import Infini from "../assets/Infini.png";
import BienVie from "../assets/BienVie.png";
import Regenyal from "../assets/Regenyal.png";
import Hyon from "../assets/Hyon.jpg";
import Revitacare from "../assets/Revitacare.png";
import Cytosial from "../assets/Cytosial.jpg";
import Cortexil from "../assets/Cortexil.png";
import IalSystem from "../assets/IalSystem.png";
import Revicell from "../assets/Revicell.png";
import PlatinumCollection from "../assets/PlatinumCollection.png";
import AcademieGroupe from "../assets/AcademieGroupe.png";
import styles from "./BrandsSection.module.scss";

export const BrandsSection = ({ title, btnText }) => {
  const isTablet = useMobile("950px");
  const isMobile = useMobile("393px");

  const {
    isModalOpen: isDisabledElementModalOpen,
    open: openDisabledElementModal,
    close: closeDisabledElementModal,
    toggle: toggleDisabledElementModal,
  } = useModal(false);

  return (
    <>
      <div className={styles.brandsContainer}>
        <p className={styles.brandsContainer__title}>{title}</p>
        <div className={styles.brandsContainer__tables}>
          {isMobile ? (
            <div className={styles.brandsWrapperMobile}>
              <div className={styles.brandsWrapperMobile__brand}>
                <img src={Kntech} className={styles.brandImg} alt="Kntech" />
              </div>
              <div className={styles.brandsWrapperMobile__brand}>
                <img src={Epline} className={styles.brandImg} alt="Epline" />
              </div>
              <div className={styles.brandsWrapperMobile__brand}>
                <img
                  src={Phitogen}
                  className={styles.brandImg}
                  alt="Phitogen"
                />
              </div>
              <div className={styles.brandsWrapperMobile__brand}>
                <img src={Infini} className={styles.brandImg} alt="Infini" />
              </div>
              <div className={styles.brandsWrapperMobile__brand}>
                <img src={BienVie} className={styles.brandImg} alt="BienVie" />
              </div>
              <div className={styles.brandsWrapperMobile__brand}>
                <img
                  src={Regenyal}
                  className={styles.brandImg}
                  alt="Regenyal"
                />
              </div>
            </div>
          ) : isTablet ? (
            <div className={styles.brandsWrapperTablet}>
              <div className={styles.brandsWrapperTablet__brand}>
                <img src={Kntech} className={styles.brandImg} alt="Kntech" />
              </div>
              <div className={styles.brandsWrapperTablet__brand}>
                <img src={Epline} className={styles.brandImg} alt="Epline" />
              </div>
              <div className={styles.brandsWrapperTablet__brand}>
                <img
                  src={Phitogen}
                  className={styles.brandImg}
                  alt="Phitogen"
                />
              </div>
              <div className={styles.brandsWrapperTablet__brand}>
                <img src={Infini} className={styles.brandImg} alt="Infini" />
              </div>
              <div className={styles.brandsWrapperTablet__brand}>
                <img src={BienVie} className={styles.brandImg} alt="BienVie" />
              </div>
              <div className={styles.brandsWrapperTablet__brand}>
                <img
                  src={Regenyal}
                  className={styles.brandImg}
                  alt="Regenyal"
                />
              </div>
              <div className={styles.brandsWrapperTablet__brand}>
                <img src={Hyon} className={styles.brandImg} alt="Hyon" />
              </div>
              <div className={styles.brandsWrapperTablet__brand}>
                <img
                  src={Revitacare}
                  className={styles.brandImg}
                  alt="Revitacare"
                />
              </div>
            </div>
          ) : (
            <>
              <div className={styles.brandsWrapperLeft}>
                <div
                  className={`${styles.brandsWrapperLeft__brand} ${styles.brandsWrapperLeft__brand1}`}
                >
                  <img
                    src={Kntech}
                    className={styles.brandImgLarge}
                    alt="Kntech"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperLeft__brand} ${styles.brandsWrapperLeft__brand2}`}
                >
                  <img
                    src={Epline}
                    className={styles.brandImgMedium}
                    alt="Epline"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperLeft__brand} ${styles.brandsWrapperLeft__brand3}`}
                >
                  <img
                    src={Phitogen}
                    className={styles.brandImgMedium}
                    alt="Phitogen"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperLeft__brand} ${styles.brandsWrapperLeft__brand4}`}
                >
                  <img
                    src={Infini}
                    className={styles.brandImgSmall}
                    alt="Infini"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperLeft__brand} ${styles.brandsWrapperLeft__brand5}`}
                >
                  <img
                    src={BienVie}
                    className={styles.brandImgSmall}
                    alt="BienVie"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperLeft__brand} ${styles.brandsWrapperLeft__brand6}`}
                >
                  <img
                    src={Regenyal}
                    className={styles.brandImgSmall}
                    alt="Regenyal"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperLeft__brand} ${styles.brandsWrapperLeft__brand7}`}
                >
                  <img src={Hyon} className={styles.brandImgSmall} alt="Hyon" />
                </div>
              </div>

              <div className={styles.brandsWrapperRight}>
                <div
                  className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand8}`}
                >
                  <img
                    src={Revitacare}
                    className={styles.brandImgSmall}
                    alt="Revitacare"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand9}`}
                >
                  <img
                    src={Cytosial}
                    className={styles.brandImgSmall}
                    alt="Cytosial"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand10}`}
                >
                  <img
                    src={Cortexil}
                    className={styles.brandImgSmall}
                    alt="Cortexil"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand11}`}
                >
                  <img
                    src={IalSystem}
                    className={styles.brandImgSmall}
                    alt="IalSystem"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand12}`}
                >
                  <img
                    src={Revicell}
                    className={styles.brandImgMedium}
                    alt="Revicell"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand13}`}
                >
                  <img
                    src={PlatinumCollection}
                    className={styles.brandImgMedium}
                    alt="PlatinumCollection"
                  />
                </div>
                <div
                  className={`${styles.brandsWrapperRight__brand} ${styles.brandsWrapperRight__brand14}`}
                >
                  <img
                    src={AcademieGroupe}
                    className={styles.brandImgLarge}
                    alt="AcademieGroupe"
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div className={styles.brandsContainer__buttonBlock}>
          <div className={styles.brandsContainer__button}>
            <Button
              variant="disabled"
              size="large"
              onClick={openDisabledElementModal}
            >
              {btnText}
            </Button>
          </div>
        </div>
      </div>
      <DisabledElementModal
        isModalOpen={isDisabledElementModalOpen}
        open={openDisabledElementModal}
        close={closeDisabledElementModal}
        toggle={toggleDisabledElementModal}
      />
    </>
  );
};
